import { useTableContext } from "#Contexts/TableContext"

const ErrorState = ({ children, centerInContainer = false }) => {
  const { table, error, tableContainerRef } = useTableContext()
  if (!error) return null

  if (centerInContainer) {
    return (
      <tbody className="empty-table">
        <tr>
          <td colSpan={table.getFlatHeaders().length} className="c-table__td relative">
            <div
              className="relative inset-0 flex flex-col justify-center items-center py-4 pointer-events-none"
              style={{
                left: tableContainerRef?.current ? -tableContainerRef.current.scrollLeft : 0,
                width: tableContainerRef?.current?.clientWidth || "100%",
              }}
            >
              {children !== undefined && children}
              {children === undefined && (
                <>
                  <i className="text-2xl mb-4 text-content-muted fa fa-exclamation-triangle" />
                  <h2 className="c-heading--base">Something is wrong</h2>
                  <p className="text-content-secondary text-center">
                    We were unable to load this table. Please try again or contact our support if
                    the problem persists.
                  </p>
                </>
              )}
            </div>
          </td>
        </tr>
      </tbody>
    )
  }

  return (
    <tbody className="empty-table">
      <tr>
        <td colSpan={table.getFlatHeaders().length} className="c-table__td">
          <div className="flex flex-col w-full h-full justify-center items-center">
            {children !== undefined && children}
            {children === undefined && (
              <>
                <i className="text-2xl mb-4 text-content-muted fa fa-exclamation-triangle" />
                <h2 className="c-heading--base">Something is wrong</h2>
                <p className="text-content-secondary text-center">
                  We were unable to load this table. Please try again or contact our support if the
                  problem persists.
                </p>
              </>
            )}
          </div>
        </td>
      </tr>
    </tbody>
  )
}

ErrorState.propTypes = {
  children: PropTypes.node,
  centerInContainer: PropTypes.bool,
}

export default ErrorState
